import ItemBlurb from './ItemBlurb';

export default ItemBlurb;
